import styled from '@emotion/styled';

export const Header = styled.header`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 9px 20px;
	background: #fff;
	border-bottom: 1px solid ${({ theme }) => theme.colors.gray5};
	min-height: 72px;

	@media ${({ theme }) => theme.medias.desktop} {
		box-shadow: none;
		padding: 15px 20px;
		min-height: auto;
	}
`;

export const Wrapper = styled.div`
	display: flex;
	align-items: center;
	width: 100%;
	min-width: 0;

	& > button:first-of-type {
		background: transparent;
		margin-right: 12px;
		height: 32px;
	}
`;

export const UserImage = styled.div`
	border-radius: 50%;
	background: ${({ theme }) => theme.colors.gray2};
	width: 32px;
	min-width: 32px;
	height: 32px;
	margin-right: 8px;

	font-size: 16px;
	font-weight: 300;
	color: #fff;

	display: flex;
	justify-content: center;
	align-items: center;
`;

export const UserInfo = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	min-width: 0;
	flex: 1;
`;

export const Name = styled.h3`
	font-weight: 500;
	font-size: 16px;
	line-height: 150%;
	margin-right: 7px;
`;

export const BlockedLabel = styled.span`
	display: flex;
	align-items: center;
	gap: 4px;
	color: #E55C39;
	font-family: 'Poppins', sans-serif;
	font-size: 12px;
	font-weight: 500;
	line-height: 150%;
	letter-spacing: 0;

	svg {
		width: 14px;
		height: 14px;

		path {
			fill: #E55C39;
		}
	}
`;
